import html from "html-literal";

export default () => html`
  <div class="pageDescription">
    <h1>About Us</h1>
    <br />
    <p>
      Grown @ Home is a platform for gardeners to sell their home-grown
      produce,<br />
      and for consumers to purchase fresh vegetables from their neighbors.
      <br /><br />
      Founded in Independence, Missouri 2022.
    </p>
    <br />
  </div>
`;
